import { render } from "./IndexView.vue?vue&type=template&id=a86fd0d2&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=a86fd0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86fd0d2"]])

export default __exports__